/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { CompanyCreateDto } from '../../models/company-create-dto';
import { CompanyItem } from '../../models/company-item';

export interface CompanyControllerCreate$Params {
      body: CompanyCreateDto
}

export function companyControllerCreate(http: HttpClient, rootUrl: string, params: CompanyControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: CompanyItem;
}>> {
  const rb = new RequestBuilder(rootUrl, companyControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: CompanyItem;
      }>;
    })
  );
}

companyControllerCreate.PATH = '/company';
